import React from 'react';
import DirectorateProfile from './DirectorateProfile';

/** Route wrapper for /directoratedetails/:slug on the main portal. */
export default function SingleDirectorate({ match }) {
    const { slug } = match.params;
    // Keyed by slug so moving between directorates resets search and paging.
    return <DirectorateProfile key={slug} slug={slug} />;
}
